import React, {useEffect, useState} from 'react';
import {Row, Col, Modal} from 'react-bootstrap';
import BlueButton from '../components/BlueButton/BlueButton.js';
import {TextField} from '@mui/material';
import moment from 'moment';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import {toast} from 'react-toastify';
import CheckboxFilter from './CheckboxFilter.js';
import {word} from "../word.js";
import {useSelector} from "react-redux";
import Loader from "./BlueButton/Loader.js";
import SuccessToast from "./BlueButton/SuccessToast.js";
import ErrorToast from "./BlueButton/ErrorToast.js";
import Api from "../Api.js";

// import { MultiTask } from '../../../api';

const AddMultipleTask = ({show, onHide}) => {
    const [submited, setSubmited] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [visibleForClient, setVisibleForClient] = useState(true);
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));
    const [images, setImages] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const login = useSelector((state) => state.manager.employee);

    const [form, setForm] = useState([
        {key: 'name', value: '', errorMessage: 'empty_error', type: 'textarea', valid: true},
        {key: 'text', value: '', errorMessage: 'empty_error', type: 'textarea', valid: true},
        {key: 'company', value: [], option: 'orgs', errorMessage: 'select_error', type: 'dropDown', valid: true}
    ]);
    const companies = useSelector((state) => state.task.companies);

    const [limitData, setLimitData] = useState({
        orgs: [],
    });
    useEffect(() => {
        (async () => {
            setLimitData({
                orgs: companies.map(s => ({value: s.id, label: s.name,})),
            })
        })()
    }, [])
    const handleSubmit = async () => {
        try {
            setSubmited(true);
            setDisabled(true);

            const profession = localStorage.getItem('profession');
            const creator = login.user.url;
            const postCompany = form.find(f => f.key === 'company').value.map(c => c.value);

            const formData = new FormData();
            images.forEach((img, index) => formData.append(`file${index + 1}`, img, img.name));
            form.forEach(({key, value}) => key !== 'company' && formData.append(key, value));

            formData.append(profession, login.url);
            formData.append('company', postCompany);
            formData.append('selectAll', selectAll);
            formData.append('visible_for_client', visibleForClient);
            formData.append('end_date', endDate);
            formData.append('creator', creator);
            await Api.createMultipleTask(formData)
            setDisabled(false);
            SuccessToast()
            onHide()
        }catch (e) {
            setDisabled(false);
            ErrorToast()
        }


    };

    const handleFileUpload = (e) => {
        const selectedFiles = Array.from(e.target.files);

        selectedFiles.forEach((file) => {
            const reader = new FileReader();

            reader.onloadend = () => {
                setImages((prevImages) => {
                    const isDuplicate = prevImages.some(
                        (img) => img.name === file.name && img.size === file.size
                    );
                    return isDuplicate ? prevImages : [...prevImages, file];
                });
            };

            reader.readAsDataURL(file);
        });
    }
    const deletePhoto = (itemToDelete) => {
        setImages((prevImages) =>
            prevImages.filter((img) => img !== itemToDelete)
        );
    };
    return (
        <Modal
            {...{onHide, show}}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                             className="w-100 d-flex flex-row justify-content-between">
                    <span>{word.new_recommendations}</span>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide}/>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <Row className="d-flex justify-content-around">
                        <Col xs={12} sm={10}>
                            {form.map((item, index) => (
                                item.type === 'textarea' ? (
                                    <div className='input-validation'>
                                    <TextField key={index}
                                               label={word[item.key]}
                                               variant='outlined'
                                               multiline
                                               value={item.value}
                                               onChange={(e) => {
                                                   const updatedForm = [...form];
                                                   updatedForm[index].value = e.target.value;
                                                   setForm(updatedForm);
                                               }}
                                               error={!item.valid && submited}
                                    />
                                    </div>
                                ) : item.type === 'dropDown' && !selectAll ? (
                                    <div className='input-validation'><Select key={index}
                                            isMulti
                                            options={limitData[item.option]}
                                            components={makeAnimated()}
                                            placeholder={word[item.key]}
                                            onChange={(selected) => {
                                                const updatedForm = [...form];
                                                updatedForm[index].value = selected;
                                                setForm(updatedForm);
                                            }}
                                    />
                                    </div>
                                ) : null
                            ))}
                            <TextField
                                id='datetime-local'
                                label='Վերջնաժամկետ'
                                type='datetime-local'
                                onChange={(e) => setEndDate(e.target.value)}
                                variant='outlined'
                                InputLabelProps={{shrink: true}}
                            />
                            <CheckboxFilter title='Տեսանելի բոլորի համար' my_task={visibleForClient}
                                            onChange={() => setVisibleForClient(!visibleForClient)}/>
                            <label className='cont'>Ընտրել բոլոր կազմակերպությունները
                                <input type='checkbox' checked={selectAll}
                                       onChange={() => setSelectAll(!selectAll)}/>
                                <span className='checkmark'/>
                            </label>
                            <div className="img-icon-cont">
                                <div className="img-cont">
                                    {images.map((item, index) =>
                                        index < 4 ? (
                                            <div className="img" key={index}>
                                                <span className={(item.type === 'image/jpeg' || item.type === 'image/png') ? 'icon-Photos' : 'icon-files-empty'}/>
                                                <span className="images-name">{item.name}</span>
                                                <i className="fas fa-times" onClick={() => deletePhoto(item)}/>
                                            </div>
                                        ) : (
                                            '...'
                                        )
                                    )}
                                </div>
                                <label>
                                    <span className="icon-Attachment"/>
                                    <input
                                        type="file"
                                        multiple
                                        className="input-icon"
                                        onChange={handleFileUpload}
                                    />
                                </label>
                            </div>
                            <div className='line-blue'/>

                            {disabled && <Loader type='Oval' color='#101C2A' height={30} width={30}/>}
                            <BlueButton disabled={disabled} title={word.create} onChangeValue={handleSubmit}/>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AddMultipleTask;